import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '../ui/dialog';

interface ClearOnboardingConfirmModalProps {
  open: boolean;
  email: string;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

export default function ClearOnboardingConfirmModal({
  open,
  email,
  onClose,
  onConfirm,
  isLoading,
}: ClearOnboardingConfirmModalProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen && !isLoading) onClose();
      }}
    >
      <DialogContent data-testid="clear-onboarding-modal" className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-display text-[20px]">Clear onboarding?</DialogTitle>
          <DialogDescription>
            This permanently deletes the children, assessments and programme registration for{' '}
            <span className="font-semibold">{email}</span>. The account and its login are kept, and
            the next app start begins onboarding again. This cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-2">
          <button
            data-testid="clear-onboarding-cancel"
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 text-sm font-semibold rounded-pine-input border-[1.5px] border-pine-line text-pine-ink-soft hover:bg-pine-hover-button transition-colors disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            data-testid="clear-onboarding-confirm"
            onClick={onConfirm}
            disabled={isLoading}
            className="px-4 py-2 text-sm font-semibold rounded-pine-input border-[1.5px] border-pine-danger text-pine-danger hover:bg-pine-danger hover:text-white transition-colors disabled:opacity-50"
          >
            {isLoading ? 'Clearing...' : 'Clear onboarding'}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
